// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2jP2n","content":"LayoutSettings_content__3PgQV"};